import React from "react";
import { Helmet } from "react-helmet";
import "../styles/TermsOfService.css";
import HomeFooter from "../components/Home/HomeFooter";
import MainHeader from "../components/Main/MainHeader";

export default function TermsOfService() {
  return (
    <>
    <MainHeader />
    <div className="tos-container">
      {/* SEO Meta Info */}
      <Helmet>
        <title>Terms of Service | Anyworq – Bangalore’s Trusted Service Platform</title>
        <meta
          name="description"
          content="Review the Terms of Service for Anyworq, your one-stop platform for A to Z services in Bangalore. Learn about user responsibilities, dealer policies, and service guidelines."
        />
        <meta
  name="keywords"
  content="Anyworq Terms of Service, Anyworq policies, Bangalore service platform, dealer agreement, user terms"
/>
<script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Terms of Service – Anyworq",
  "description": "Official Terms of Service for Anyworq, the A to Z service platform in Bangalore.",
  "publisher": {
    "@type": "Organization",
    "name": "Anyworq",
    "url": "https://www.anyworq.com"
  }
})}
</script>


      </Helmet>

      {/* Page Title */}
      <h1 className="tos-title">Terms of Service – Anyworq</h1>
      <p className="tos-updated">Last Updated: September 26, 2025</p>

      <p>
        By accessing or using <b>Anyworq</b> (the “Platform”), you agree to
        comply with these Terms of Service. Please read them carefully. If you
        do not agree with any part of these Terms, you must not use the
        Platform.
      </p>

      {/* Sections */}
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By using Anyworq, you acknowledge that you have read, understood, and
          agreed to these Terms of Service. These Terms govern your access to
          and use of the platform, including all services, features, and content
          provided.
        </p>
      </section>

      <section>
        <h2>2. Services Offered</h2>
        <ul>
          <li>
            Anyworq acts as a facilitator, connecting users with verified service
            providers across all categories (A to Z) in Bangalore.
          </li>
          <li>We provide dealer profiles, service matching, and enquiry management.</li>
          <li>
            Anyworq does not guarantee the quality, safety, timeliness, or
            outcomes of services provided by third-party dealers.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. User Responsibilities</h2>
        <ul>
          <li>Provide accurate and up-to-date information during registration and service enquiries.</li>
          <li>Use the platform only for lawful purposes.</li>
          <li>Refrain from any misuse, unauthorized access, hacking, or abuse of the platform.</li>
          <li>Resolve any disputes or disagreements with dealers amicably and in accordance with platform guidelines.</li>
        </ul>
      </section>

      <section>
        <h2>4. Dealer Responsibilities</h2>
        <ul>
          <li>Maintain accurate, complete, and updated profiles.</li>
          <li>Provide genuine, professional, and lawful services to customers.</li>
          <li>Comply with all applicable laws, regulations, and professional standards.</li>
          <li>Cooperate in resolving disputes raised through the platform.</li>
        </ul>
      </section>

      <section>
        <h2>5. Payments</h2>
        <ul>
          <li>Payments may be processed through the Anyworq platform or directly to dealers, depending on the service.</li>
          <li>Users agree to pay all applicable service fees and charges as described during the transaction.</li>
          <li>Anyworq is not liable for disputes or issues arising from direct payments to dealers outside the platform.</li>
        </ul>
      </section>

      <section>
        <h2>6. Limitation of Liability</h2>
        <ul>
          <li>Anyworq is a facilitator platform only and does not provide services directly.</li>
          <li>We are not responsible for the quality, legality, safety, or timeliness of services provided by dealers.</li>
          <li>Users and dealers are responsible for resolving disputes directly. Anyworq may assist in mediation but is not liable for damages or losses.</li>
        </ul>
      </section>

      <section>
        <h2>7. Termination</h2>
        <ul>
          <li>Anyworq reserves the right to suspend or terminate accounts at its discretion if users or dealers violate these Terms, engage in fraudulent activity, or otherwise misuse the platform.</li>
          <li>Termination may occur without prior notice, and Anyworq is not liable for any consequences arising from such termination.</li>
        </ul>
      </section>

      <section>
        <h2>8. Governing Law</h2>
        <p>
          These Terms are governed by the laws of India, and any disputes arising
          will be subject to the exclusive jurisdiction of the courts in
          Bangalore.
        </p>
      </section>

      {/* FAQ */}
      <section className="tos-faq">
        <h2>Terms of Service – FAQ</h2>
        <div className="faq-item">
          <p className="question"> What services does Anyworq provide?</p>
          <p>
            Anyworq connects users in Bangalore with verified dealers offering A
            to Z services, from home repairs to professional business support.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> Is Anyworq responsible for the quality of dealer services?</p>
          <p>
            Anyworq acts as a facilitator only. While dealers are verified, the
            actual service is delivered by them. Users should confirm details and
            agreements directly with dealers.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> How are payments handled?</p>
          <p>
            Payments may be made through the Anyworq platform or directly to
            dealers. Any disputes from direct payments are the responsibility of
            the user and dealer.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> Can my account be suspended or terminated?</p>
          <p>
            Yes. Anyworq reserves the right to suspend or terminate accounts that
            violate policies, engage in fraud, or misuse the platform.
          </p>
        </div>
        <div className="faq-item">
          <p className="question"> Which city does Anyworq serve?</p>
          <p>
            Currently, Anyworq provides services exclusively in Bangalore, with
            plans to expand to other cities in the future.
          </p>
        </div>
      </section>
    </div>
    <HomeFooter />
    </>
  );
}
